import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {NgxCurrencyConfig, NgxCurrencyInputMode} from 'ngx-currency';

@Component({
    selector: 'app-question-label-percent-json',
    templateUrl: './question-label-percent-json.component.html',
    styleUrls: ['./question-label-percent-json.component.scss'],
    standalone: false
})
export class QuestionLabelPercentJsonComponent implements OnInit, AfterViewInit {

  @Input() question: Question;
  @Input() showTotal = true;
  @Output() questionAnswer = new EventEmitter<any>();

  //questions: Question[] = [];
  questions: any = [];
  maskOptions: NgxCurrencyConfig;
  total = 0;
  constructor(public globalQuestionService: GlobalQuestionService) {
  }

  ngOnInit(): void {

      if (this.question) {
        try {
          if (this.question.options) {
            this.questions = JSON.parse(this.question.options);
          } else {
            this.questions = JSON.parse(this.question.answer);
          }
        } catch { }
      }
    
  }

  ngAfterViewInit(): void {
    
  }

  get totalAmount(): number {
    let total = 0;
    for (const a of this.questions) {
      total += +a.list_value;
    }
    return total;
  }

  saveValue(): void {
    if (this.question && this.totalAmount <= 100 ) {
      this.question.answer = JSON.stringify(this.questions);
      console.log(this.question)
    }
    this.questionAnswer.emit(this.question);
  }
  onChange(value: any, index: number): void {
    console.log(value,index)
    if (value?.answer) {
     
      this.total = 0;
      for (const q of this.questions) {
        if (q?.answer?.includes('|')) {
          this.total += +q.answer.split('|')[1];
        } else {
          this.total += +q.answer;
        }
      }
    }
  }

}
